import { call, put, takeEvery } from 'redux-saga/effects';

import { REDUX_STORE } from '@funnels/constants';
import { FetchLeadAction, StoreLead } from '@funnels/types';
import { datadogUtil } from '@funnels/utils';

import { waitForAuth } from '../_common';
import { fetchLeadFail, fetchLeadSuccess } from '../actions';
import LeadAPI from './api';

export function* fetchLeadWorker(action: FetchLeadAction): any {
  try {
    yield waitForAuth();
    const { leadID } = action;
    const response = yield call(LeadAPI.fetch, leadID);
    const lead = response.data.lead;

    yield put(fetchLeadSuccess(lead as StoreLead));
  } catch (e: any) {
    datadogUtil.addError(e);
    yield put(fetchLeadFail(e.response?.data || e.message));
  }
}

export function* leadWatcher() {
  yield takeEvery(REDUX_STORE.LEAD.ACTION_TYPES.FETCH_LEAD, fetchLeadWorker);
}

export default leadWatcher;
